import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import checkoutApi from 'api/requests/checkout';
import establishmentsApi from 'api/requests/establishments';
import { FullyCentered } from 'styled/alignment/Center';
import Loader from 'components/_UI/Loader';
import Text from 'components/_UI/Text';
import Button from 'components/_UI/Button';
import { Column } from 'styled/alignment/Column';
import colors from 'theme/colors';
import indexPriority from 'theme/z-index';
import { Row } from 'styled/alignment/Row';
import { useCheckout } from 'context/checkout/Checkout';
import TicketItem from './TicketItem';
import breakpoints from 'theme/breakpoints';
import PaymentForm from '../payment/Payment';
import FreePaymentForm from '../payment/FreePayment';
import ProductItem from './ProductItem';
import buttonText from 'texts/buttons/buttonText';
import currency from 'helpers/currency';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import Modal from 'components/_UI/Modal';
import CheckoutCollapse from 'modules/events/page/collapse/CheckoutCollapse';
import routeParams from 'theme/routeParams';
import auth from 'middlewares/auth';
import LoginModal from 'modules/onboarding/sign-in/LoginModal';
import paths from 'routes/paths';
import { PRODUCT_TYPES } from '../commom/paymentFormUtils';
import { trackEvent } from 'scripts/pixels';
import { Check, ShoppingCart, Tag, X } from 'lucide-react';
import Fieldset from 'components/_UI/Fieldset';
import promotionalCodesApi from 'api/requests/promotionalCodes';
export default function CheckoutOrderMinimal({ event, establishment }) {
    const location = useLocation();
    const navigate = useNavigate();

    const { checkout, setCheckout } = useCheckout();
    const [searchParams, setSearchParams] = useSearchParams();

    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [originalPriceTotal, setOriginalPriceTotal] = useState(0)
    const [error, setError] = useState(false)
    const [getTicketsError, setGetTicketsError] = useState('')
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false)
    const [couponCode, setCouponCode] = useState('')
    const [couponId, setCouponId] = useState('')
    const [cartItems, setCartItems] = useState([])
    const [couponTrigger, setCouponTrigger] = useState(0)
    const [errorMinOrder, setErrorMinOrder] = useState(false)
    const [createOrderError, setCreateOrderError] = useState('')
    const [componentToRender, setComponentToRender] = useState(false)
    const [goToLoginModal, setGoToLoginModal] = useState(false)
    const [loginModalCount, setLoginModalCount] = useState(0);
    const [isPix, setIsPix] = useState(false);
    const [pixToRender, setPixToRender] = useState(false);
    const [fullscreenImage, setFullscreenImage] = useState(null);
    const [activeOverlayProductId, setActiveOverlayProductId] = useState(null);
    const [promotionalCode, setPromotionalCode] = useState()
    const [typeDiscount, setTypeDiscount] = useState()
    const [errorCode, setErrorCode] = useState(false)
    useEffect(() => {
        const couponParam = searchParams.get('coupon');

        if (couponParam) {
            setCouponCode(couponParam);
            getOrder(couponParam)
            return
        }

        setTotalPrice(0);
        setOriginalPriceTotal(0);
        setCouponCode('');
        setCheckout({});
        setCartItems([]);
        getOrder();
    }, [event]);


    const handleOpenImage = (imgUrl) => {
        setFullscreenImage(imgUrl);
    };

    const handleCloseImage = () => {
        setFullscreenImage(null);
    };


    async function getOrder(coupon) {
        setLoading(true);
        const hiddenCode = searchParams.get(routeParams.payments.hiddenCode)

        try {
            if (establishment) {

                const { data } = await establishmentsApi.getProducts(establishment.slug)
                if (data && data.data) {

                    setProducts(
                        data.data
                            .filter(product => product?.batches?.[0]?.quantity_available > 0 && Boolean(product?.batches?.[0]?.is_active))
                            .map(product => {
                                const batches = product.batches.map(batch => {
                                    return {
                                        ...batch,
                                        original_price: batch?.original_price || batch.price
                                    }
                                })

                                return {
                                    ...product,
                                    batches
                                }
                            })
                    )
                }
            }

            if (event && !establishment && coupon !== 'remove') {

                const { data } = await checkoutApi.getTickets(event?.slug, coupon ? { params: { coupon, hidden_code: hiddenCode } } : { params: { hidden_code: hiddenCode } });

                setTickets(data?.items?.filter(el => el.type === PRODUCT_TYPES.TICKET));
                setProducts(data?.items?.filter(el => el.type === PRODUCT_TYPES.PRODUCT));
                setCouponId(data?.coupon_id);

                if (coupon) {
                    setCouponCode(data?.coupon_id ? coupon : null);
                    setGetTicketsError('')

                    setTotalPrice(0)
                    setOriginalPriceTotal(0)
                    setCheckout({})
                }
            }


            if (coupon == 'remove') {
                const { data } = await checkoutApi.getTickets(event?.slug, { hidden_code: hiddenCode });


                setTickets(data?.items?.filter(el => el.type === PRODUCT_TYPES.TICKET));
                setProducts(data?.items?.filter(el => el.type === PRODUCT_TYPES.PRODUCT));
                setCouponId(null);

                if (coupon) {

                    setCouponCode(null);
                    setGetTicketsError('')

                    setTotalPrice(0)
                    setOriginalPriceTotal(0)
                    setCheckout({})
                }
            }



        } catch (error) {
            setGetTicketsError('Código promocional inválido.');
        } finally {
            setLoading(false);
        }
    }

    const getCoupon = async (code, slug) => {
        setLoading(true)
        if (errorCode) {
            setErrorCode(false)
        }
        try {
            const data = await promotionalCodesApi.getCoupon(slug, code)
            setTypeDiscount(data.data.data.total_discount)
            getOrder(code)
        } catch (error) {
            setLoading(false)
            setErrorCode(true)
        }
    }


    const handleUpdateTotal = (priceChange, originalPriceChange) => {
        if (!auth.getToken()) {
            setLoginModalCount(loginModalCount + 1)

            if (loginModalCount > 0) {
                setGoToLoginModal(true);
                return
            }
        }

        // setLoginModalCount(0)
        setTotalPrice((prevTotal) => (parseFloat(prevTotal) + priceChange));
        setOriginalPriceTotal((prevTotal) => (parseFloat(prevTotal) + originalPriceChange));
    }

    async function buy() {
        if (!auth.getToken()) {
            setGoToLoginModal(true);
            return;
        }

        const payload = {
            ...checkout
        }

        if (event) {
            payload.event_id = event.id
        }

        if (establishment) {
            payload.establishment_id = establishment.id
        }

        if (couponId) {
            payload.coupon_id = couponId
        }

        if (totalPrice < 5 && totalPrice !== 0) {
            setErrorMinOrder('Valor mínimo do pedido é de 5 reais!')
            return
        }

        if (!payload?.batches?.length) {
            setError(true)
            return
        }

        setLoading(true);

        try {
            trackEvent('InitiateCheckout');
            const { data } = await checkoutApi.createOrder(payload);

            setTotalPrice(0);
            setOriginalPriceTotal(0);

            setCheckout({ ...checkout, orderId: data.id });
            setSearchParams({ 'checkout': 1 })

            if (Number(totalPrice) === 0) {
                setComponentToRender(() => (
                    <StyledCheckoutOrder>
                        <FreePaymentForm
                            tickets={cartItems}
                            event={event}
                        />
                    </StyledCheckoutOrder>
                ))
            } else {
                setComponentToRender(() => (
                    <StyledCheckoutOrder>
                        <PaymentForm
                            tickets={cartItems}
                            totalPrice={totalPrice}
                            onPixTrigger={(pixComponent) => renderPix(pixComponent)}
                            onPaymentSuccess={onCloseCollapse}
                        />
                    </StyledCheckoutOrder>
                ))
            }

        } catch ({ response }) {
            if (response?.status === 401) {
                setGoToLoginModal(true);
                return;
            }

            if (response?.data?.key === 'expired_batch') {
                handleExpiredBatchError()
            }

            if (response?.data?.message === 'Tickets not available') {
                handleBatchSoldOutError()
            }
        } finally {
            setLoading(false);
        }
    }

    function removeCode() {
        getOrder('remove')
    }

    function renderPix(PixComponent) {
        setIsPix(true);
        setPixToRender(() => (<PixComponent />))
    }

    function toggleCouponModal() {
        if (!auth.getToken()) {
            setLoginModalCount(loginModalCount + 1)

            if (loginModalCount > 0) {
                setGoToLoginModal(true);
                return
            }
        }

        setIsCouponModalVisible(!isCouponModalVisible)
        setGetTicketsError('');
    }

    function handleExpiredBatchError() {
        setCreateOrderError('Algum de seus ingressos se esgotaram. Recarregando a página.')

        setTimeout(() => {
            setCreateOrderError('')
            setCheckout({})
            getOrder()
        }, 1500)
    }

    function handleBatchSoldOutError() {
        setCreateOrderError('Algum de seus ingressos se esgotaram. Recarregando a página.')

        setTimeout(() => {
            setCreateOrderError('')
            setCheckout({})
            getOrder()
        }, 1500)
    }

    function onCloseCollapse() {
        setTotalPrice(0);
        setOriginalPriceTotal(0);
        setCouponCode('');
        setCheckout({});
        setCartItems([]);
        setComponentToRender(false);
        setIsPix(false);
        setSearchParams((prevSearchParams) => {
            const newSearchParams = new URLSearchParams(prevSearchParams);
            newSearchParams.delete(routeParams.payments.checkout)

            return newSearchParams;
        });
        getOrder();
    }

    function navigateToLogin() {
        const currentParams = new URLSearchParams(location.search);
        currentParams.set('redirectTo', location.pathname);

        navigate({
            pathname: paths.login,
            search: currentParams.toString()
        });
    }

    const [showLoginModal, setShowLoginModal] = useState(false);

    return (
        <>
            {
                loading
                    ? (
                        <FullyCentered height='300px'>
                            <Loader />
                        </FullyCentered>
                    )
                    : (
                        <>
                            <Container>
                                <Head fullyCentralized>
                                    <ShoppingCart color={colors.occasionalPurple} size={20} />
                                    <Text
                                        type='bold'
                                        paddingBottom={0}
                                        marginLeft={'10px'}
                                        color={colors.occasionalPurple}
                                    >
                                        Seu pedido
                                    </Text>
                                </Head>

                                <ContainerCode>
                                    <CouponButton>
                                        {
                                            isCouponModalVisible ? (
                                                <Button
                                                    width={'300px'}
                                                    variant='promoted'
                                                    category='squired'
                                                    size='small'
                                                    style={{
                                                        border: errorCode ? `2px solid ${colors.danger}` : `1px solid ${colors.success}`,
                                                        padding: `10px`,
                                                        background: couponCode ? '#f0fdf4' : 'none'
                                                    }}

                                                >
                                                    <Column>
                                                        <Row verticalCenter>
                                                            <Tag width={18} color={errorCode ? colors.danger : colors.successDark} />
                                                            <Text
                                                                color={colors.nightDark}
                                                                paddingBottom={0}
                                                                type='bold'
                                                                marginLeft={'8px'}
                                                            >
                                                                Código promocional
                                                            </Text>
                                                        </Row>
                                                        <Row>
                                                            <ContentFieldCode>
                                                                {
                                                                    couponCode ? (
                                                                        <CardCode>
                                                                            <ContentTextCode>
                                                                                <Check color={colors.successDark} size={'18px'} />
                                                                                <Text color={colors.successDark} marginLeft={'5px'} paddingBottom={'0px'}>
                                                                                    {couponCode}
                                                                                </Text>
                                                                                <CardTypeDiscount>
                                                                                    <Text color={colors.successDark}>
                                                                                        {typeDiscount} OFF
                                                                                    </Text>
                                                                                </CardTypeDiscount>
                                                                            </ContentTextCode>
                                                                            <X color={colors.nightDark} size={16} onClick={() => removeCode()} />
                                                                        </CardCode>

                                                                    ) : (
                                                                        <>
                                                                            <Fieldset
                                                                                placeholder='Digite seu código'
                                                                                layout='squired'
                                                                                onChangeValue={e => setPromotionalCode(e)}
                                                                            />

                                                                            {
                                                                                loading ?
                                                                                    <Loader /> :
                                                                                    <ButtonApplyCode onClick={() => getCoupon(promotionalCode, event.slug)}>{buttonText.apply}</ButtonApplyCode>
                                                                            }
                                                                        </>
                                                                    )
                                                                }

                                                            </ContentFieldCode>
                                                        </Row>
                                                        {
                                                            Boolean(errorCode) &&
                                                            <ContentErrorCode>
                                                                <Text color={colors.danger}>Código inválido!</Text>
                                                            </ContentErrorCode>
                                                        }

                                                    </Column>


                                                </Button>
                                            ) : (
                                                <Button
                                                    onClick={toggleCouponModal}
                                                    width={'300px'}
                                                    variant='promoted'
                                                    category='squired'
                                                    size='small'
                                                    style={{ border: `1px solid ${colors.success}` }}
                                                >
                                                    <Tag width={18} />
                                                    <Text
                                                        color={colors.success}
                                                        paddingBottom={0}
                                                        type='bold'
                                                        marginLeft={'8px'}
                                                    >
                                                        {buttonText.addCoupon}
                                                    </Text>
                                                </Button>

                                            )
                                        }



                                    </CouponButton>
                                </ContainerCode>

                                <TicketsContainer
                                // isProducts={products.length > 0}
                                >

                                    {
                                        tickets.length > 0 && (
                                            <>
                                                <Text
                                                    type='bold'
                                                    textAlign={'center'}
                                                    marginTop={'6px'}
                                                    color={colors.occasionalPurple}
                                                >
                                                    Ingressos
                                                </Text>

                                                <Tickets>
                                                    {
                                                        tickets.map(el => {
                                                            if (el?.batches?.length > 0) {
                                                                return el.batches.map(item => (
                                                                    <TicketItem
                                                                        minimal
                                                                        loginModalCount={loginModalCount}
                                                                        key={item.id}
                                                                        ticket={item}
                                                                        soldout={el?.soldout}
                                                                        finished={el?.finished}
                                                                        type={el?.type}
                                                                        description={el?.description}
                                                                        saleType={el.sale_type}
                                                                        couponTrigger={couponTrigger}
                                                                        selectedTickets={cartItems}
                                                                        setSelectedTickets={setCartItems}
                                                                        onChangeTotalValue={handleUpdateTotal}
                                                                    />
                                                                ));
                                                            }

                                                            if (el?.soldout || el?.finished) {
                                                                return (
                                                                    <TicketItem
                                                                        minimal
                                                                        loginModalCount={loginModalCount}
                                                                        key={el.id}
                                                                        ticket={{
                                                                            id: el.id,
                                                                            name: el.name,
                                                                            description: el.description,
                                                                            price: el.price,
                                                                            original_price: el.price,
                                                                            quantity: 0,
                                                                            is_active: 0,
                                                                        }}
                                                                        soldout={el?.soldout}
                                                                        finished={el?.finished}
                                                                        type={el?.type}
                                                                        description={el?.description}
                                                                        saleType={el.sale_type}
                                                                        couponTrigger={couponTrigger}
                                                                        selectedTickets={cartItems}
                                                                        setSelectedTickets={setCartItems}
                                                                        onChangeTotalValue={handleUpdateTotal}
                                                                    />
                                                                );
                                                            }

                                                            return null;
                                                        })
                                                    }
                                                </Tickets>
                                            </>
                                        )
                                    }
                                </TicketsContainer>



                                <TicketsContainer isTypeProduct>
                                    {
                                        products.length > 0 && (
                                            <>
                                                <Text type='bold' textAlign={'center'} marginTop={0} color={colors.occasionalPurple}>
                                                    Produtos
                                                </Text>

                                                <Text textAlign={'center'} color={colors.night}>
                                                    Compre agora e retire no evento.
                                                </Text>
                                                <Tickets>
                                                    {
                                                        products.map((el, index) => (
                                                            <ProductItem
                                                                minimal
                                                                loginModalCount={loginModalCount}
                                                                key={index}
                                                                selectedProducts={cartItems}
                                                                setSelectedProducts={setCartItems}
                                                                couponTrigger={couponTrigger}
                                                                product={el}
                                                                onChangeTotalValue={handleUpdateTotal}
                                                                activeOverlayProductId={activeOverlayProductId}
                                                                onImageClick={(e) => handleOpenImage(e)}
                                                                onMouseEnter={() => setActiveOverlayProductId(el.id)}
                                                                onMouseLeave={() => setActiveOverlayProductId(null)}
                                                            />
                                                        ))
                                                    }
                                                </Tickets>
                                            </>
                                        )}
                                </TicketsContainer>

                                <Footer>
                                    {
                                        loading ? (
                                            <FullyCentered>
                                                <Loader />
                                            </FullyCentered>
                                        ) : (
                                            <>
                                                {
                                                    originalPriceTotal === totalPrice && (
                                                        <Row style={{ justifyContent: 'space-between' }}>
                                                            <Text type='bold' color={colors.night} paddingBottom={0}>
                                                                Total
                                                            </Text>

                                                            <Text name='highlight' color={colors.occasionalPurple}>
                                                                {currency.format(totalPrice)}
                                                            </Text>
                                                        </Row>
                                                    )
                                                }

                                                {
                                                    originalPriceTotal !== totalPrice &&
                                                    <Column>
                                                        <Row style={{ justifyContent: 'space-between' }}>
                                                            <Text type='bold' color={colors.night} paddingBottom={0}>
                                                                Subtotal
                                                            </Text>

                                                            <Text>
                                                                {currency.format(originalPriceTotal)}
                                                            </Text>
                                                        </Row>

                                                        <Row style={{ justifyContent: 'space-between' }}>
                                                            <Text type='bold' color={colors.night} paddingBottom={0}>
                                                                Desconto
                                                            </Text>

                                                            <Text color={colors.success}>
                                                                {currency.format((originalPriceTotal - totalPrice))}
                                                            </Text>
                                                        </Row>

                                                        <Row style={{ justifyContent: 'space-between' }}>
                                                            <Text type='bold' color={colors.night} paddingBottom={0}>
                                                                Total
                                                            </Text>

                                                            <Text name='highlight' color={colors.occasionalPurple}>
                                                                {currency.format(totalPrice)}
                                                            </Text>
                                                        </Row>
                                                    </Column>
                                                }

                                                {errorMinOrder && (
                                                    <FullyCentered>
                                                        <Text color={colors.danger} name='small'> {errorMinOrder}</Text>
                                                    </FullyCentered>
                                                )}

                                                <Button
                                                    size='medium'
                                                    category='squired'
                                                    variant={checkout?.batches?.length == 0 ? 'disabled' : 'featured'}
                                                    onClick={buy}
                                                >
                                                    Finalizar compra
                                                </Button>


                                                {createOrderError && (
                                                    <FullyCentered>
                                                        <Text color={colors.danger} name='small'>{createOrderError}</Text>
                                                    </FullyCentered>
                                                )}
                                            </>
                                        )
                                    }
                                </Footer>
                            </Container>


                            <CheckoutCollapse
                                visible={searchParams.get(routeParams.payments.checkout) == 1 && !!componentToRender}
                                onClose={onCloseCollapse}
                            >
                                {!isPix ? componentToRender : pixToRender}
                            </CheckoutCollapse>
                            {/* {
                                componentToRender && (
                                )
                            } */}


                        </>
                    )

            }

            {
                goToLoginModal && (
                    <LoginModal
                        isOpen={goToLoginModal}
                        onClose={() => setGoToLoginModal(false)}
                    />
                )
            }

            <Modal isOpen={error} onClose={() => setError(false)}>
                <Column verticalCenter>
                    <Text color={colors.danger}>Você deve selecionar pelo menos 1 item!</Text>
                    <ContentButton>
                        <Button onClick={() => setError(false)} marginTop={'15px'}>
                            {buttonText.understood}
                        </Button>
                    </ContentButton>
                </Column>
            </Modal>

            {fullscreenImage && (
                <ModalOverlay onClick={handleCloseImage}>
                    <ModalContent>
                        <img src={fullscreenImage} alt="Produto" />
                    </ModalContent>
                </ModalOverlay>
            )}
        </>
    )
}

const StyledCheckoutOrder = styled(Column)`
    height: 100%;
`;

const Head = styled(Row)`
    background: #fff5fb;
    border-radius: 8px 8px 0 0;
    padding: 16px;
    width: 100%;
`;

const Container = styled.div`
    width: 100%;
    height: auto;
    /* padding-bottom: 300px; */
    /* background-color: #fefefe; */
    background-color: ${colors.neutralLight};    
    box-shadow: 0 0 4px #ccc;
    /* box-shadow: 0 2px 5px #ccc; */
    padding: 30px;
    border-radius: 8px;
    border: 1px solid ${colors.neutralDark};
    padding: 0 12px;
    position: sticky;
    top: 110px;    

    @media screen and (min-width: ${breakpoints.lg}) {
        width: 100%;
        padding: 0 !important;
    }
`;

const Footer = styled(FullyCentered)`
    flex-direction: column;
    width: 100%;
    padding: 10px;
    background: ${colors.neutralLight};
    /* box-shadow: 0 -2px 8px #ddd; */
    border-top: 1px solid ${colors.nightLight};
    padding-top: 10px;

    & > button {
        margin-top: 20px;
    }
    
    @media screen and (min-width: ${breakpoints.lg}) {
        padding-top: auto;
        padding-bottom: 10px;
        margin-bottom: 0;
        padding: 24px;

        /* & >  p {
            padding: 16px 0;
        } */

        & > button { 
            width: 100%;
            margin-bottom: 6px;
            box-shadow: unset;
            padding: 14px 10px;
        }
    }
`;

const CouponButton = styled(FullyCentered)`
    display: flex;
    flex-direction: column;
    margin-top: 10px;

    & > button {
        box-shadow: unset;
        padding: 6px;
    }
    
`;

const TicketsContainer = styled(FullyCentered)`
    flex-direction: column;
    width: 100%;
    padding-bottom: 20px;
`;

const Tickets = styled(Column)`
    width: 100%;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        width: 100%;
        background-color: ${colors.neutralLight};
        padding: 0 20px;
    }
`;


const ContentButton = styled(Row)`
    width: 270px;
`

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${indexPriority.threeDS + 1};
`;

const ModalContent = styled.div`
    max-width: 90%;
    max-height: 90%;

  @media screen and (min-width: ${breakpoints.lg}) {
    max-width: 45%;
    max-height: 45%;  
  }

  img {
    max-width: 100%;
    max-height: 100%;
    margin-top: -25%;
    border-radius: 8px;
  }
`;
const ContentFieldCode = styled(Row)`
    align-items: center;
    justify-content: flex-start;
    
    margin-top: 10px;
    & > div {
        
        padding-bottom: 0px;
        & > input {
            margin-top: 0px;
        }
    }
    
`
const ButtonApplyCode = styled.button`
    width: 100px;
    height: 37px;
    background: ${colors.occasionalPurple};
    border-radius: 6px;
    cursor: pointer;
    color: ${colors.neutralLight};
    transition: all ease-in-out .25s;
    margin-left: 5px;
`;

const ContainerCode = styled(Column)`
    width: 100%;
    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 15px;
    }
`


const CardCode = styled.div`
    display: flex;
    align-items: center;
    padding: 0 10px;
    flex-direction: row;
    border: 1px solid #ccc;
    background: ${colors.neutralLight};
    border-radius: 6px;
    height: 37px;
    width: 100%;
    justify-content: space-between;
    position: relative;
   
`

const CardTypeDiscount = styled.div`
    width: auto;
    height: 20px;
    background: #f0fdf4;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    padding: 5px;
    & > p {
        padding-bottom: 0;
        font-size: 11px;
    }
`

const ContentErrorCode = styled(Row)`
    justify-content: flex-start;
    margin-top: 10px;

    & > p {
        font-size: 12px;
        padding-bottom: 0px;
        
    }
`
const ContentTextCode = styled(Row)`
    justify-content: flex-start;
    & > p {
        display: flex;
        align-items: center;
    }
`